// Actual jobs on a chosen day, shared by the Diary, Today and the server's phone reads.
// An agreed or completed suggestion/reminder is now a job; an unplaced week never is.
export interface DayVisit {
  state: string
  source?: string | null
  confirmed?: number | boolean | null
  created_by?: string | null
}
const UNPLACED_SOURCES: readonly string[] = ['suggested', 'tentative', 'week']
export function countsAsDayVisit(v: DayVisit): boolean {
  if (v.state !== 'booked' && v.state !== 'done') return false
  return !(v.state === 'booked' && !v.confirmed && (
    UNPLACED_SOURCES.includes(v.source ?? '') ||
    v.source !== 'manual' && v.created_by === 'importer'))
}
export function dayVisitCounts(visits: readonly DayVisit[]): { done: number; total: number } {
  const jobs = visits.filter(countsAsDayVisit)
  return { done: jobs.filter(v => v.state === 'done').length, total: jobs.length }
}
// Same exclusion as above for SQL reads. Alias comes only from the app's own SQL builders.
export function notOnADaySql(k: string): string {
  return `(${k}.state = 'booked' AND COALESCE(${k}.confirmed, 0) = 0 AND (COALESCE(${k}.source, '') IN ('${UNPLACED_SOURCES.join("', '")}') OR (COALESCE(${k}.source, '') <> 'manual' AND ${k}.created_by = 'importer')))`
}
